import * as React from 'react';
import { ContentList } from '../../../Blocks/ContentListBlock/ContentList';
import { LinkListSection } from '../../../Partials/LinkListSection/LinkListSection';
import { LinkWithDescriptionListSection } from '../../../Partials/LinkWithDescriptionListSection/LinkWithDescriptionListSection';
import { SectionWithAnchor } from '../../../Partials/NavigationBlock/SectionWithAnchor';
import { PersonInfoList } from '../../../Partials/PersonInfoList/PersonInfoList';
import type { DepartmentSectionsProps } from '../ViewModel/DepartmentSectionsProps.csharp';

export const DepartmentPageSections: React.FC<React.PropsWithChildren<DepartmentSectionsProps>> = props => {
    const { administrationSection, relatedProjectsSection, newsSection, relatedStudiesSection } = props;

    return (
        <div className="DepartmentPage__sections">
            <SectionWithAnchor
                section={administrationSection}
                renderContent={sectionProps => (
                    <PersonInfoList {...sectionProps} link={sectionProps.employeeListPageLink} />
                )}
            />
            <SectionWithAnchor
                section={relatedProjectsSection}
                renderContent={sectionProps => <LinkWithDescriptionListSection {...sectionProps} />}
            />
            <SectionWithAnchor
                section={newsSection}
                renderContent={sectionProps => <ContentList {...sectionProps} />}
            />
            <SectionWithAnchor
                section={relatedStudiesSection}
                renderContent={sectionProps => <LinkListSection {...sectionProps} />}
            />
        </div>
    );
};
